<template>
  <svg aria-hidden="true">
    <use :xlink:href="symbolId" :fill="color" :class="fillClass" />
  </svg>
</template>

<script lang="ts" setup name="SvgIcon">
import { computed } from 'vue'

const props = defineProps({
  // 显示的svg
  name: {
    type: String,
    required: true
  },
  // svg图标的颜色
  color: {
    type: String
  },
  // tailwind 指定的颜色类名
  fillClass: {
    type: String
  }
})

// 真实显示的svg图标
const symbolId = computed(() => `#icon-${props.name}`)
</script>
